<div class="d-flex navigation-header">
    <h1 (click)="goBack()" id="admin">{{"admin.title" | translate }}</h1>
    <h1>&nbsp;> {{"admin.users.title" | translate}}</h1>
    <button mat-flat-button color="primary" (click)="openNewUserDialog()" [ngClass]="(!isEnglish()) ? 'add-new-user-de' : 'add-new-user-en'">{{'admin.users.addNew' | translate}}</button>
</div>
<div class="order-table">
    <table mat-table [dataSource]="items" matSort class="mat-elevation-z8">

        <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef [width]="420" mat-sort-header>{{"admin.users.username" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.username}}</td>
        </ng-container>

        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef [width]="420" mat-sort-header>{{"admin.users.fullName" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.fullName}}</td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.users.role" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.role}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header">{{"admin.users.actions" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="actions">
                <div class="d-flex">
                    <img src="assets/img/icons/edit.svg" [matTooltip]="'home.orders.tooltips.edit' | translate" matTooltipPosition="above" (click)="openEditUserDialog(row)">
                    <img src="assets/img/icons/delete2.svg" [matTooltip]="'home.orders.tooltips.delete' | translate" matTooltipPosition="above" (click)="deleteUser(row)">
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" #userPaginator="matPaginator"></mat-paginator>
</div>
